import React from 'react'
import { Select } from '../../../ui/core'

export default function ParagraphimageSettings({ block, onChange}) {
    const handleChange = (value) =>{
        let tmpBlock = Object.assign({}, block);
        tmpBlock.alignImage = value;
        onChange(tmpBlock); 
    } 
    return (
        <div>
           {block &&  <Select label='uitlijning afbeelding' id='selectalignment' value={block.alignImage || 'right'} onChange={(ev)=>{handleChange(ev.target.value)}}>
                <option value='right'>rechts</option>
                <option value='left'>links</option>
            </Select>}
        </div>
    )
}
